// extracted by mini-css-extract-plugin
export default {"card":"uQVDr6Fjj3YVPqlhuXdx","cardContent":"yObtn_4J1qrKrEy1nUTy","cardHeading":"ACoKXzj4flBzMDdH0QOs","cardFooter":"Xl79iKCjDfVYkkZ_QVGw"};